/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum QuantityMetric {
    Distance = 0,
    WeightTonnes = 1,
    Count = 2,
    WeightKilograms = 3,
    LocationSpecific = 4,
}
